var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99994 6.75005C8.20501 6.75005 6.74994 8.20512 6.74994 10C6.74994 11.795 8.20501 13.25 9.99994 13.25C11.7949 13.25 13.2499 11.795 13.2499 10C13.2499 8.20512 11.7949 6.75005 9.99994 6.75005Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76948 1.08151C8.2176 0.696136 11.7823 0.696136 15.2304 1.08151C17.1288 1.29369 18.66 2.78947 18.8828 4.69452C19.2951 8.21952 19.2951 11.7806 18.8828 15.3056C18.66 17.2106 17.1288 18.7064 15.2304 18.9186C11.7823 19.304 8.2176 19.304 4.76948 18.9186C2.87108 18.7064 1.33989 17.2106 1.11707 15.3056C0.704791 11.7806 0.704791 8.21952 1.11707 4.69452C1.33989 2.78947 2.87108 1.29369 4.76948 1.08151ZM14.9999 4.00005C14.4477 4.00005 13.9999 4.44776 13.9999 5.00005C13.9999 5.55233 14.4477 6.00005 14.9999 6.00005C15.5522 6.00005 15.9999 5.55233 15.9999 5.00005C15.9999 4.44776 15.5522 4.00005 14.9999 4.00005ZM5.24994 10C5.24994 7.37669 7.37659 5.25005 9.99994 5.25005C12.6233 5.25005 14.7499 7.37669 14.7499 10C14.7499 12.6234 12.6233 14.75 9.99994 14.75C7.37659 14.75 5.24994 12.6234 5.24994 10Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstagram);
export default __webpack_public_path__ + "static/media/ic_instagram.2a216a97dd6723fdae01710f1f5ebdf4.svg";
export { ForwardRef as ReactComponent };